import { StatResultResponse } from '@business/entities/dashboard';
import { Formatter } from '@core/utils/formatter';
import { R } from '@core/utils/r';
import React, { memo } from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import CountUp from 'react-countup';
import { Card, CardTitle } from 'reactstrap';
import { WidgetProps } from '../types';
import './styles.css';
import { ProgressCircleWidgetConfigData } from './ProgressCircleWidgetConfig';
import { WidgetIcons } from '../BaseWidget';

export const ProgressCircleWidget = memo((props: WidgetProps<StatResultResponse, ProgressCircleWidgetConfigData>) => {
  const { settings, result, config } = props;

  const minSide = R.min([settings.grid.h, settings.grid.w]) || settings.grid.h;
  const size = minSide * 100 + 10 - 68;
  const fontSize = size / 6;

  return (
    <Card className="p-4" style={{ marginBottom: 0, flex: 1 }}>
      <CardTitle className="mb-4 d-flex align-items-center flex-row">
        {settings.title || 'Progress Circle'} <WidgetIcons {...props} />
      </CardTitle>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: size }}>
          <CircularProgressbarWithChildren
            styles={buildStyles({
              pathColor: config && !R.isEmpty(config.color) ? config.color : `#556ee6`,
            })}
            value={result ? result?.progress : 35}
          >
            <div className="progress-circle-dashboard">
              <h1 className="mb-0" style={{ fontSize }}>
                <CountUp preserveValue end={result ? result?.value : 35} duration={1} decimals={0}></CountUp>
              </h1>
              <small style={{ fontSize: fontSize * 0.5 }} className="text-muted">
                {Formatter.formatInteger(result?.total || 0)}
              </small>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    </Card>
  );
});
